module.exports = __webpack_public_path__ + "img/IMG_9605.37ead102.jpg";